import styled from "@emotion/styled"
import { Dialog } from "@blueprintjs/core"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const TabsContainer = styled.div`
  margin-bottom: 20px;
`

export const ShortLocateDialog = styled(Dialog)({
  width: "650px",
  borderRadius: "6px",
  ".bp3-dialog-header": {
    background: SCIENT_COLORS.darkGray3,
    padding: "12px 16px",
    borderBottom: `1px solid ${SCIENT_COLORS.darkGray5}`,
  },
  ".bp3-dialog-body": {
    margin: "0",
    padding: "16px",
  },
  ".bp3-dialog-footer": {
    padding: "12px 16px",
    borderTop: `1px solid ${SCIENT_COLORS.darkGray5}`,
    marginTop: "8px",
  },
  ".bp3-dialog-footer-actions": {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
  },
})
